import styled from 'styled-components';

const FlexRow = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: ${(props: { justify?: string }) =>
    props.justify ? props.justify : 'space-between'};
  align-items: center;
  width: '100%';
`;

export default FlexRow;
